import { useEffect } from "react";
import type { History } from "history";
import type { ParsedQuery } from "query-string";

interface UsePaginationUrlProps {
  history: History;
  page: number;
  pageQueryName?: string;
  queryParams: ParsedQuery<string>;
}

export const usePaginationUrl = ({
  page,
  queryParams,
  history,
  pageQueryName = "page",
}: UsePaginationUrlProps) => {
  useEffect(() => {
    const currentPageInUrl = Number(queryParams[pageQueryName] || 1);

    if (currentPageInUrl !== page) {
      const urlSearchParams = new URLSearchParams(history.location.search);

      if (page > 1) {
        urlSearchParams.set(pageQueryName, String(page));
      } else {
        urlSearchParams.delete(pageQueryName);
      }

      history.push({
        search: urlSearchParams.toString(),
      });
    }
  }, [page, history]);
};
